


class NotificationClass{
    constructor(){
        this.main = document.getElementById('notification');

        this._icon = this.main.querySelector('.icon');
        this._text = this.main.querySelector('.text');
        this._actionBtn = this.main.querySelector('.action_btn');
        this._closeBtn = this.main.querySelector('.close_btn');
        
        this._resolveFunction = null;

        this._timeout = null;

        this._firstTime = true;

        this._isOpen = false;

        this._actionBtn.addEventListener('click', this._onClickActionBtn.bind(this));
        this._closeBtn.addEventListener('click', this._onClickCloseBtn.bind(this));
    }

    show(text, icon = null, actionBtnText = null, actionBtnStyle = null, duration = 2500){
        let delay = 0;
        if(this._isOpen){
            this._hide();

            delay = 500;
        }

        setTimeout(()=>{
            this._isOpen = true;
            
            // Text
            this._text.innerHTML = text;
            
            // Icon
            this._icon.style.display = 'flex';
            switch(icon){
                case 'delete':
                    this._icon.innerHTML = /*html*/`<i class="material-icons color-red-500 material-icons--size-2">delete</i>`;
                break;
                case 'done':
                    this._icon.innerHTML = /*html*/`<i class="material-icons color-green-600 material-icons--size-2">done</i>`;
                break;
                case 'warning':
                    this._icon.innerHTML = /*html*/`<i class="material-icons color-orange-300 material-icons--size-2">warning</i>`;
                break;    
                default:
                    this._icon.style.display = 'none';
                break;
            }
            
            
            // Button
            if(actionBtnText != null){
                this._actionBtn.innerHTML = actionBtnText;
                
                this._actionBtn.classList.remove('link');
                this._actionBtn.classList.remove('link--underline');
                this._actionBtn.classList.remove('button');

                switch(actionBtnStyle){
                    case 'link': 
                        this._actionBtn.classList.add('link');
                        this._actionBtn.classList.add('link--underline');
                    break;
                    case 'button':
                    default:
                        this._actionBtn.classList.add('button');
                    break;            
                }

                this._actionBtn.parentElement.style.display = 'inline-flex';
            }else{
                this._actionBtn.parentElement.style.display = 'none';
            }

            // Si es la primera vez pongo delay porque se ve el transition
            if(this._firstTime){
                this._firstTime = false;
                
                setTimeout(()=>{
                    this.main.classList.add('notification--show');
                }, 300);
            }else{
                this.main.classList.add('notification--show');
            }

                       


            clearTimeout(this._timeout);
            this._timeout = setTimeout(this._onTimeout.bind(this), duration);
            
        }, delay)

        return new Promise((resolve, reject)=>{
            this._resolveFunction = resolve;
        })
    }

    _hide(){
        this._isOpen = false;
        this.main.classList.remove('notification--show');
    }

    _onClickActionBtn(e){
        e.preventDefault();
        e.stopPropagation();
        
        this._hide();
        clearTimeout(this._timeout);
        this._resolveFunction(true);
    }

    _onClickCloseBtn(e){
        this._hide();
        clearTimeout(this._timeout);
        this._resolveFunction(false);
    }

    _onTimeout(){
        this._hide();

        this._resolveFunction(false);
    }

}

const Notification = new NotificationClass();

Object.seal(Notification);

export default Notification;